import "../../styles/header.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faCircleUser,
  faKey,
  faRightFromBracket
} from "@fortawesome/free-solid-svg-icons";
import logo from "../../assets/imgs/giwasco_logo.png"
import { useState, useEffect, useRef } from "react";
import Dropdown from "../dropdown";
import { Auth } from "../Login/Auth";

export default function StaffHeader (props) {
    const [isSlightlyScrolled, setIsSlightlyScrolled] = useState(false);
    const [isScrolledByVh, setIsScrolledByVh] = useState(false);
    const [toggleMenu, setToggleMenu] = useState(false);
    const [showUserMenu, setShowUserMenu] = useState(false);
    const userMenuRef = useRef(null);

    // When the user scrolls, run this function...  
    useEffect(() => {
        const handleScroll = () => {
        if (window.pageYOffset > 70 && window.pageYOffset < window.innerHeight+100) {
            setIsSlightlyScrolled(true);
        } else {
            setIsSlightlyScrolled(false);
        }
        
        if (window.pageYOffset > window.innerHeight+100) {
            setIsScrolledByVh(true);
        } else {
            setIsScrolledByVh(false);
        }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
        window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        const handleContextMenu = (e) => {
        e.preventDefault();
        };

        document.addEventListener('contextmenu', handleContextMenu);

        return () => {
        document.removeEventListener('contextmenu', handleContextMenu);
        };
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
            userMenuRef.current &&
            !userMenuRef.current.contains(event.target)
            ) {
            setShowUserMenu(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener(
            "mousedown",
            handleClickOutside
            );
    };
    }, []);

    const handleLogout = async () => {
        try {
            const res = await fetch("/api/auth/logout", {
            method: "POST",
            credentials: "include",
            headers: {
                Accept: "application/json",
            },
            });

            const data = await res.json();

            if (!res.ok || !data?.success) {
            throw new Error("Logout failed");
            }

            // 🔥 THIS is what guarantees ProtectedRoute updates
            Auth.clearToken();

            window.location.href = "/stafflogin";
        } catch (err) {
            console.error("Logout error:", err);

            // fallback safety
            Auth.clearToken();
            window.location.href = "/stafflogin";
        }
        };

    return (
        <div className= {isScrolledByVh ?  "header scrolledByVh" : isSlightlyScrolled ? "header" : "header nobg"}>
            <div className="navigation">
                <div className="logo">
                    <img src={logo} alt="" />
                    {/* <h1>Githunguri Water & Sanitation Company Ltd.</h1> */}
                </div>
                <div className="navlinks">
                    <a href="/">Home</a>
                    <Dropdown title="Media" items = {
                        {"View Reports" : "/admin/reports", 
                            "Post new news" : "/admin/postnews",
                            "Post new media" : "/admin/postmedia" }} isSlightlyScrolled={isSlightlyScrolled}/>
                    <Dropdown title="Careers" items = {
                        {"View Careers" : "/admin/careers", 
                            "Post new career" : "/admin/postcareer" }} isSlightlyScrolled={isSlightlyScrolled}/>
                    <Dropdown title="Tenders" items = {
                        {"View Tenders" : "/admin/tenders", 
                            "Post new tender" : "/admin/posttender" }} isSlightlyScrolled={isSlightlyScrolled}/>
                    <a href="/gis">GIS</a>
                </div>
                <div className="header-actions">

                    <div className="user-menu" ref={userMenuRef}>
                        <FontAwesomeIcon
                            icon={faCircleUser}
                            className="user-icon"
                            onClick={() =>
                                setShowUserMenu(!showUserMenu)
                            }
                        />

                        {showUserMenu && (
                            <div className="user-dropdown">
                                <a href="/admin/changepass">
                                    <FontAwesomeIcon icon={faKey} />
                                    Change Password
                                </a>

                                <button onClick={handleLogout}>
                                    <FontAwesomeIcon
                                        icon={faRightFromBracket}
                                    />
                                    Logout
                                </button>
                            </div>
                        )}
                    </div>

                    <div className="menu">
                        <FontAwesomeIcon
                            icon={faBars}
                            onClick={() =>
                                props.setToggleMenu(
                                    !props.toggleMenu
                                )
                            }
                        />
                    </div>

                </div>
            </div>
        </div>
    );
}